import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_PAGES } from './shared/globals';

const routes: Routes = [
  // only put routes here that do not need the sidemenu/header (e.g. login, 404, etc.)
  {
    path: APP_PAGES.login.url,
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  { // main-app here (lazy loaded)
    path: '',
    loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuModule)
  },
  { path: '**', redirectTo: "login" }, // TODO: add 404/doesn't exist page
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
